// extracted by mini-css-extract-plugin
export default {"KnownDetailsBody":"KnownDetailsCards_KnownDetailsBody__1VfOS"};